export enum Collection {
  USERS = "users",
  PRICES = "prices",
  PRODUCTS = "products"
}
